// extracted by mini-css-extract-plugin
export default {"wrapper":"QKhj4","block":"YadpP","text":"ogUHx"};